export default '7D26E';
